import { defineStore } from 'pinia';

export type HeaderState = {
  isHeaderOpen: boolean;
};

export const useHeaderStore = defineStore('main-nav', {
  state: (): HeaderState => {
    return {
      isHeaderOpen: false,
    };
  },
  actions: {
    setIsHeaderOpen(newState: HeaderState['isHeaderOpen']) {
      this.isHeaderOpen = newState;
    },
  },
});
